import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { Error } from './error'

const propTypes = {
  i18n: PropTypes.shape({
    error403: PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.string,
    }).isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  showHeader: PropTypes.bool,
}

const defaultProps = {
  children: undefined,
  showHeader: false,
}

export function Error403({ i18n, children, showHeader }) {
  return (
    <Error
      showHeader={showHeader}
      heading={i18n.error403.heading}
      content={i18n.error403.content}
    >
      {children}
    </Error>
  )
}

Error403.propTypes = propTypes
Error403.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(Error403)
